import { Injectable } from '@angular/core';
import { environment } from '@rms/env';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private logLevels: Record<string, number> = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
  };

  private currentLogLevel: number;

  constructor() {
    this.currentLogLevel = environment.production ? this.logLevels['error'] : this.logLevels['debug'];
  }

  public debug(payload: unknown, entity: string): void {
    if (this.shouldLog('debug')) {
      console.debug(this.logLabel('DEBUG', entity), payload);
    }
  }

  public info(payload: unknown, entity: string): void {
    if (this.shouldLog('info')) {
      console.info(this.logLabel('INFO', entity), payload);
    }
  }

  public warn(payload: unknown, entity: string): void {
    if (this.shouldLog('warn')) {
      console.warn(this.logLabel('WARN', entity), payload);
    }
  }

  public error(payload: unknown, entity: string): void {
    if (this.shouldLog('error')) {
      // No synthetic stack: it only captures the logger's own call site, not the
      // caller. A real Error payload already carries its own (accurate) stack.
      console.error(this.logLabel('ERROR', entity), payload);
    }
  }

  private shouldLog(level: string): boolean {
    return this.logLevels[level] >= this.currentLogLevel;
  }

  private logLabel(name: string, entity: string): string {
    return `[${name}] [${entity}] ${new Date().toISOString()}`;
  }
}
